import { ENDPOINTS } from '@shared/utils/constant'
import { BaseAccount } from '@injectivelabs/sdk-ts/core/accounts'
import { ChainRestAuthApi } from '@injectivelabs/sdk-ts/client/chain'

export const getAccountDetails = async (address: string) => {
  const chainRestAuthApi = new ChainRestAuthApi(ENDPOINTS.rest)
  const accountDetailsResponse = await chainRestAuthApi.fetchAccount(address)

  return BaseAccount.fromRestApi(accountDetailsResponse).toAccountDetails()
}
